import "../scss/page.scss";
import "../scss/password-reset.scss";
import initPasswordToggles from "./scripts/common/password-toggle.js";
import "./scripts/password-reset/base.js";

initPasswordToggles();
